/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /*
  * Collection card swatches: clicking a swatch swaps the card image in place
  * instead of navigating to the product page. Scoped to grid swatch fieldsets
  * ([data-grid-swatch-fieldset]) so PDP swatches and sibling swatches keep
  * their default behavior. The theme's own GridSwatch element still handles
  * the hover preview; `is-selected` persists the chosen image after the
  * pointer leaves the card (hover cleanup only removes `is-visible`).
  */
  function selectGridSwatch(link) {
    var swatchButton = link.closest('[data-swatch-button]');
    var productItem = link.closest('[data-grid-item]');
    if (!swatchButton || !productItem) return;

    var productImage = productItem.querySelector('[data-product-image]');
    if (!productImage) return;

    // Same quote normalization the theme uses when writing data-variant-title
    var variantName = (swatchButton.getAttribute('data-swatch-variant-name') || '').replace(/"/g, "'");

    productImage.querySelectorAll('[data-variant-title].is-selected').forEach(function(image) {
      image.classList.remove('is-selected');
    });

    var selectedImage = productImage.querySelector('[data-variant-title="' + variantName + '"]');
    if (selectedImage) {
      selectedImage.classList.add('is-selected');
    } else {
      // No pre-rendered variant layer — swap the card's featured image to the
      // variant's featured image (same image the PDP switches to), carried on
      // the chip as data-swatch-image.
      var swatchImage = swatchButton.getAttribute('data-swatch-image');
      var cardImage = productImage.querySelector('[data-product-image-default] img');

      if (swatchImage && cardImage) {
        cardImage.removeAttribute('srcset');
        cardImage.removeAttribute('data-srcset');
        cardImage.src = swatchImage;
      }
    }

    var fieldset = link.closest('[data-grid-swatch-fieldset]');
    if (fieldset) {
      fieldset.querySelectorAll('[data-swatch-button].is-active').forEach(function(button) {
        button.classList.remove('is-active');
      });
    }
    swatchButton.classList.add('is-active');
  }

  document.addEventListener('click', function(event) {
    var link = event.target.closest('[data-grid-swatch-fieldset] [data-swatch-link]');
    if (!link) return;

    event.preventDefault();
    event.stopPropagation();
    selectGridSwatch(link);
  });

  /*
  * Touch support: iOS treats the first tap on an element with a mouseenter
  * handler that changes the DOM (the theme's tooltip) as hover-only and
  * swallows the click. Handle the tap on touchend ourselves — but only when
  * the finger didn't move, so swiping the swatch row still scrolls it.
  * preventDefault on touchend also stops the emulated mouse events, the
  * tooltip, and the link navigation in one go.
  */
  var touchStartX = 0;
  var touchStartY = 0;

  document.addEventListener('touchstart', function(event) {
    if (!event.target.closest('[data-grid-swatch-fieldset] [data-swatch-link]')) return;
    touchStartX = event.changedTouches[0].clientX;
    touchStartY = event.changedTouches[0].clientY;
  }, { passive: true });

  document.addEventListener('touchend', function(event) {
    var link = event.target.closest('[data-grid-swatch-fieldset] [data-swatch-link]');
    if (!link) return;

    var touch = event.changedTouches[0];
    var moved = Math.abs(touch.clientX - touchStartX) > 10 || Math.abs(touch.clientY - touchStartY) > 10;
    if (moved) return; // it was a scroll/swipe, not a tap

    event.preventDefault();
    event.stopPropagation();
    selectGridSwatch(link);
  }, { passive: false });

  /*
  * Metal chips over the card image (product-grid-item.liquid,
  * metal_swatches_on_image): a click shows that metal in place. The card's
  * featured image, the links and the price switch to the chip's variant.
  * The hover image covers the card while the pointer is on it, so it steps
  * aside (`is-metal-selected`, product-grid-item-styles.liquid) until the pointer
  * leaves — otherwise the new image would only appear once it had. On touch
  * the slider is always shown, so its first slide swaps and scrolls back in.
  */
  function selectMetalSwatch(chip) {
    var productItem = chip.closest('[data-grid-item]');
    if (!productItem) return;

    var imageUrl = chip.getAttribute('data-image-url');
    if (imageUrl) {
      productItem.querySelectorAll('[data-product-image-default] img, [data-hover-slide-featured] img').forEach(function(image) {
        image.removeAttribute('srcset');
        image.removeAttribute('data-srcset');
        image.src = imageUrl;
      });

      var productImage = productItem.querySelector('[data-product-image]');
      if (productImage && !productImage.classList.contains('is-metal-selected')) {
        productImage.classList.add('is-metal-selected');
        productItem.addEventListener('mouseleave', function() {
          productImage.classList.remove('is-metal-selected');
        }, { once: true });
      }

      var slider = productItem.querySelector('hover-images [data-hover-slider]');
      if (slider) slider.scrollLeft = 0;
    }

    var variantUrl = chip.getAttribute('data-variant-url');
    if (variantUrl) {
      productItem.querySelectorAll('[data-product-link]').forEach(function(link) {
        link.href = variantUrl;
      });
    }

    // Empty for $0.00, same as product-grid-price.liquid
    var newPrice = productItem.querySelector('[data-product-price] .new-price');
    if (newPrice && chip.hasAttribute('data-price-html')) {
      newPrice.innerHTML = chip.getAttribute('data-price-html');
    }

    productItem.querySelectorAll('[data-metal-swatch]').forEach(function(button) {
      button.setAttribute('aria-pressed', button === chip ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function(event) {
    var chip = event.target.closest('[data-metal-swatch]');
    if (chip) selectMetalSwatch(chip);
  });

  /*
  * $0.00 products: no price, no add to cart on the product page and in the
  * quick-add modal. Liquid already hides the price (snippets/price.liquid) and
  * the add-to-cart form (snippets/product-buttons.liquid) on first render. The
  * theme re-renders the price on variant change but not the buy buttons, so
  * keep the form, the empty price block's spacing and the sticky cart bar in
  * sync from here.
  */
  function syncZeroPrice(productInfo, isZero) {
    var form = productInfo.querySelector('[data-product-form]');
    var priceBlock = productInfo.querySelector('[id^="Price-"]');
    var cartBar = productInfo.querySelector('cart-bar');

    if (form) form.classList.toggle('hidden', isZero);
    if (priceBlock && priceBlock.closest('.product__block')) {
      priceBlock.closest('.product__block').classList.toggle('hidden', isZero);
    }
    if (cartBar) {
      cartBar.classList.toggle('hidden', isZero);
      // The bar's height feeds the footer's bottom padding; recompute it.
      if (typeof cartBar.setCartBarHeight === 'function') cartBar.setCartBarHeight();
    }
  }

  // First render: Liquid hid the form for a $0.00 variant; hide the rest to match.
  function initZeroPrice(productInfo) {
    var form = productInfo.querySelector('[data-product-form]');
    if (form && form.classList.contains('hidden')) syncZeroPrice(productInfo, true);
  }

  document.querySelectorAll('product-info').forEach(initZeroPrice);
  document.addEventListener('theme:product-info:loaded', function(event) {
    if (event.target.matches && event.target.matches('product-info')) initZeroPrice(event.target);
  });

  if (window.subscribe && window.theme && window.theme.PUB_SUB_EVENTS) {
    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function(event) {
      var data = event && event.data;
      if (!data) return;

      document.querySelectorAll('product-info').forEach(function(productInfo) {
        var id = productInfo.dataset.originalSection || productInfo.dataset.section;
        if (id === data.sectionId) syncZeroPrice(productInfo, !!data.variant && data.variant.price === 0);
      });
    });
  }

  /*
  * Read more / Read less on <toggle-ellipsis> (description and tab content).
  * The theme's own click handler (theme.js) only ever opens, so this capture
  * listener runs first, owns both directions and stops the theme's handler.
  */
  document.addEventListener('click', function(event) {
    var button = event.target.closest && event.target.closest('toggle-ellipsis [data-button]');
    if (!button) return;
    event.stopPropagation();

    var ellipsis = button.closest('toggle-ellipsis');
    var content = ellipsis.querySelector('[data-content]');
    var actions = ellipsis.querySelector('[data-actions]');
    var isOpen = !ellipsis.classList.contains('is-open');

    // Collapsing a long description from its end would leave the visitor far below it,
    // so jump back to the block first and let it collapse in view. (A smooth scroll
    // here gets cut short by scroll anchoring while the height animates.)
    if (!isOpen) {
      var block = ellipsis.closest('.product__block') || ellipsis;
      var stickyHeader = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-sticky-height')) || 0;
      var top = block.getBoundingClientRect().top - stickyHeader;
      if (top < 0) window.scrollBy({ top: top - 20, behavior: 'instant' });
    }

    var height = isOpen ? content.offsetHeight + actions.offsetHeight : ellipsis.dataset.height;

    ellipsis.classList.toggle('is-open', isOpen);
    ellipsis.style.setProperty('--height', height + 'px');
    button.setAttribute('aria-expanded', isOpen);
    button.querySelector('span').textContent = isOpen ? button.dataset.labelLess : button.dataset.labelMore;
  }, true);

  /*
  * On Unbridaled products (any product whose page has the app's widget) the app
  * writes its own price string ("$1,000 USD") into every .price__regular and add
  * to cart button price on option and diamond changes, ahead of the theme's
  * re-render for the new variant. The theme shows prices without a currency
  * code, so drop it. Engagement rings also show "(Setting only)" after the price
  * (snippets/price.liquid): hide it while the app's price includes a paired diamond.
  */
  if (document.getElementById('unbridaled-container')) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var currencySuffix = new RegExp('\\s*' + currency + '\\s*$');
    var diamondPaired = false;

    var stripCurrency = function(el) {
      if (currencySuffix.test(el.textContent)) el.textContent = el.textContent.replace(currencySuffix, '');
    };

    var syncAppPrice = function() {
      document.querySelectorAll('.product__submit__buttons .btn__price').forEach(stripCurrency);

      document.querySelectorAll('.price__regular').forEach(function(regular) {
        // The theme renders .price-item markup (variant price); the app writes bare text
        if (regular.querySelector('.price-item')) return;
        stripCurrency(regular);

        var note = regular.closest('.price') && regular.closest('.price').querySelector('[data-setting-only]');
        if (note) note.hidden = diamondPaired;
      });
    };

    new MutationObserver(syncAppPrice).observe(document.body, { childList: true, subtree: true, characterData: true });

    window.addEventListener('message', function(event) {
      var action = event.data && event.data.message && event.data.message.action;
      if (action !== 'diamond-selected' && action !== 'diamond-unselected') return;
      diamondPaired = action === 'diamond-selected';
      syncAppPrice();
    });
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
